import React from 'react'

/**
 * RichView — renders trusted/sanitized rich-text HTML with the document's
 * prose styles (headings, lists, quotes, inline code, links). Read-only
 * counterpart to the TipTap editor.
 */
export function RichView({ html, className = '' }) {
  const cls = ['rich', 'rich-block', className].filter(Boolean).join(' ')
  return <div className={cls} dangerouslySetInnerHTML={{ __html: html || '' }} />
}
